import { createSelector } from 'reselect';

import { StoreState } from '../../../reducers';
import { ConfigsData, BgStyleData, BackgroundMediaData } from '../reducer';
import Utils from '../../../utils';

export interface BackgroundData {
	currentMedia?: BackgroundMediaData;
	defaultMedia?: BackgroundMediaData;
	defaultColors: (string | undefined)[];
}

const getConfigs = (state: StoreState): ConfigsData => state.editor.configs;

const getDataFromBgStyle = (bgStyle: BgStyleData | {}): BackgroundData | undefined => {
	if (Utils.isEmptyObject(bgStyle) || Utils.isEmptyObject((bgStyle as BgStyleData).epubStyle)) {
		return undefined;
	}

	const {
		epubStyle: {
			backgroundMedia,
			backgroundImage,
			defaultBackgroundMedia,
			backgroundColor,
		},
	} = bgStyle as BgStyleData;

	return {
		currentMedia: backgroundMedia || backgroundImage,
		defaultMedia: defaultBackgroundMedia,
		defaultColors: [backgroundColor],
	};
};

export const getSpreadBgData = createSelector(
	getConfigs,
	(state: StoreState, spread: number[]): number[] => spread,
	({ pagesData }: ConfigsData, spread: number[]): BackgroundData | undefined => {
		if (pagesData.length === 0) {
			return undefined;
		}

		const leftPage = spread[0];
		const { bgStyle } = pagesData[leftPage - 1];
		const leftPageData = getDataFromBgStyle(bgStyle);

		if (spread.length > 1) {
			const rightPage = spread[1];
			const { bgStyle } = pagesData[rightPage - 1];
			const rightPageData = getDataFromBgStyle(bgStyle);

			if (!leftPageData) {
				if (rightPageData) {
					rightPageData.defaultColors.unshift(undefined);
				}

				return rightPageData;
			}

			const rightPageColor = rightPageData ? rightPageData.defaultColors[0] : undefined;
			leftPageData.defaultColors.push(rightPageColor);
		}

		return leftPageData;
	},
);

export const getGeneralBgData = createSelector(
	getConfigs,
	({ generalData }: ConfigsData): BackgroundData | undefined => (
		getDataFromBgStyle(generalData.bgStyle)
	),
);

export const getIsTransparentPage = createSelector(
	getConfigs,
	(state: StoreState, page: number): number => page,
	({ pagesData }: ConfigsData, page: number): boolean => (
		pagesData.length > 0
			? pagesData[page - 1].isTransparent
			: false
	),
);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/Editor/selectors/spreadBackground.ts